
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getBookmarkPresentationsByID, getBookmarkPresentationsFilterFormsByBookmarkPresentation,
} from "@/helpers/ol/ol-layer-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";

export class LayerInfoCharacteristicsLayerButtonComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const id = this.getAttribute('data-id')
        const bookmarkPresentation = getBookmarkPresentationsByID(id)
        const filterForm = getBookmarkPresentationsFilterFormsByBookmarkPresentation(bookmarkPresentation)[key]

        const template = document.createElement('template');
        template.innerHTML =
        `<button class="btn btn-sm btn-outline-secondary"><span class="fa fa-filter"></span>
           ` + filterForm.Name + `
         </button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            setActiveFilter(bookmarkPresentation.ID, bookmarkPresentation.PresentationID, filterForm.ID)
        })
    }
}

